import React, { useState, Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import Tabs from 'components/Tabs';
import styles from './index.module.scss';
import cn from 'classnames';

const Switchable = ({
  tabs,
  active,
  setActive,
  className,
  panelClassName,
  tabClassName,
  resetVerticalScroll,
  viewId,
  hideTabsOnly,
}) => {
  const [activeTab, setActiveTab] = useState(active);
  const tabValues = tabs.map(tab => tab.label);

  const tabClick = view => {
    if (typeof setActive === 'function') {
      setActive(view);
    }
    setActiveTab(view);

    if (resetVerticalScroll && viewId) {
      const view = document.getElementById(viewId);
      view && view.scrollTo(0, 0);
    }
  };

  useEffect(() => {
    setActiveTab(active);
  }, [active]);

  return (
    <div className={cn(styles.panelContainer, className)}>
      {!hideTabsOnly && (
        <Tabs
          active={activeTab}
          options={tabValues}
          onClick={tabClick}
          className={tabClassName}
        />
      )}
      <div id={viewId} className={cn(styles.panel, panelClassName)}>
        {tabValues.map((tab, index) => {
          if (activeTab === tab) {
            return (
              <Fragment key={tabs[index].id || index}>
                {tabs[index].component}
              </Fragment>
            );
          } else {
            return null;
          }
        })}
      </div>
    </div>
  );
};

Switchable.propTypes = {
  tabs: PropTypes.array.isRequired,
  active: PropTypes.string.isRequired,
  setActive: PropTypes.func,
  className: PropTypes.string,
  panelClassName: PropTypes.string,
  tabClassName: PropTypes.string,
  resetVerticalScroll: PropTypes.bool,
  hideTabsOnly: PropTypes.bool,
  viewId: PropTypes.string,
};
Switchable.defaultProps = {
  hideTabsOnly: false,
};
export default Switchable;
